import React, { Redirect } from "react";
import { ToastContainer, toast, Slide } from "react-toastify";
import $ from "jquery";

import axios from '@app/lib/axios';
import DataTable from "@app/components/datatable/DataTable";

import * as Constant from "@app/Constant.js";
import * as commonData from "@app/lib/common_data";

import ModalUpdate from "./ModalUpdate";

class ManagementNurseryRefine extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            readyOk: false,
            role: localStorage.getItem("login_user_role"),
            branchId: localStorage.getItem("login_branch_id"),
            selected: null,
            showUpsert: false,
        };

        this.tableSetting = {
            ajaxOpt: { url: `/api/nursery/refine/list` },
            processing: true,
            serverSide: true,
            searching: true,
            searchingFieldVisible: true,
            searchHolder: "원 검색",
            paging: true,
            select: "single",
            scrollX: true,
            scrollY: "63vh",
            scrollCollapse: true,
            sort: false,
            lengthMenu: [
                [50, 100, 200],
                [50, 100, 200],
            ],
            filters: [
                {
                    title: "API 연동",
                    data: "api",
                    options: [
                        { name: "전체", value: "" },
                        { name: "미연동", value: "u.api_key is null" },
                        { name: "연동", value: "u.api_key is not null" },
                    ],
                },
                {
                    title: "검수 여부",
                    data: "isRefined",
                    options: [
                        { name: "전체", value: "" },
                        { name: "미검수", value: "n.is_refined = 0" },
                        { name: "완료", value: "n.is_refined = 1" },
                    ],
                },
            ],
            columns: [
                { title: "ID", data: "id" },
                { title: "원 이름", data: "name" },
                { title: "원장", data: "directorName" },
                { title: "주소", data: "address" },
                { title: "계약수", data: "contractAp" },
                { title: "통합 원", data: "uniqId" },
                { title: "API", data: "apiKey" },
                { title: "검수여부", data: "isRefined" },
                { title: "관리" },
            ],
            ordering: false,
            // order: [[6, 'asc'], [7, 'asc'], [4, 'desc']],
            columnDefs: [
                {
                    targets: [0, 1, 2, 3, 4, 5, 6, 7, 8],
                    className: "dt-center text-nowrap",
                },
                {
                    targets: [0, 2, 3, 8],
                    orderable: false,
                },
                {
                    targets: 5,
                    render: (data, type, row) => {
                        return data ? `<span class="text-success">등록</span>` : `<span class="text-danger">미등록</span>`;
                    },
                },
                {
                    targets: 6,
                    render: (data, type, row) => {
                        return data ? `<span class="text-success">연동</span>` : `<span class="text-danger">미연동</span>`;
                    },
                },
                {
                    targets: 7,
                    render: (data, type, row) => {
                        return data == "1" ? `<span class="text-success">완료</span>` : `<span class="text-danger">미검수</span>`;
                    },
                },
                {
                    targets: 8,
                    className: "dt-center",
                    render: (data, type, row) => {
                        return `<button type="button" class="update-item btn btn-sm btn-primary mr-1" data-id="${row.id}">관리</button>`;
                    },
                },
            ],
        };
        this.dataTableRef = React.createRef();
    }

    componentDidMount() {
        this.getBaseInfo();
    }

    componentDidUpdate(prevProps) {}

    getBaseInfo = () => {
		commonData.getLocCodes(axios, (err, result) => {
			if(!err) {
                this.setState({ locCodes: result }, () => {
                    axios({
                        method: "GET",
                        url: `/api/nursery/refine/status`,
                    }).then((resultStatus) => {
                        this.setState({ refineStatus: resultStatus.data.data }, () => this.setState({ readyOk: true }));
                    });
                });
            }
        });
    };

    onDraw = (tableData) => {
        const self = this;
        if (tableData && tableData.length > 0) {
            $(".update-item").on("click", null, (e) => {
                const id = $(e.currentTarget).data("id");
                if (id && self.dataTableRef.current) {
                    const selected = self.dataTableRef.current.getData(id);
                    if (selected) {
                        self.setState({
                            selected,
                            showUpsert: true,
                        });
                    }
                }
            });
        }
    };

    onCUD = (msg) => {
        this.dataTableRef.current.reloadData();
        this.setState({
            showUpsert: false,
            selected: false,
        });
        toast.success(msg);
    };

    render() {
        const { selected, showUpsert, readyOk, locCodes, refineStatus } = this.state;
        if (this.state.role === "branch") {
            return <Redirect to="/" />;
        } else {
            return (
                <div className="dashboard-wrapper">
                    <div className="dashboard-ecommerce">
                	    <div className="container-fluid dashboard-content bg-white box-shadow-down pb-2">
                            <div className="row">
                                <div className="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12">
                                    <div className="page-header">
                                        <h2 className="pageheader-title">통합 원 - TAS 원 정보 연동</h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="container-fluid dashboard-content">
                            {readyOk && (
                                <div>
                                    <div className="row">
                                        <div className="col">
                                            <div className="card border-top border-3 border-top-danger mb-0">
                                                <div className="card-header app-stat h5 pt-1 mb-0">TAS 원</div>
                                                <div className="card-body metric-value p-2">
                                                    <div className="d-flex flex-row-reverse h6">{refineStatus.countNursery}</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col">
                                            <div className="card border-top border-3 border-top-danger mb-0">
                                                <div className="card-header app-stat h5 pt-1 mb-0">검수 완료</div>
                                                <div className="card-body metric-value p-2">
                                                    <div className="d-flex flex-row-reverse h6">
                                                        <span className="text-success">{`(${((refineStatus.countRefined / refineStatus.countNursery) * 100).toFixed(2)}%)`}</span>
                                                        <span className="pr-1">{refineStatus.countRefined}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col">
                                            <div className="card border-top border-3 border-top-danger mb-0">
                                                <div className="card-header app-stat h5 pt-1 mb-0">통합 원</div>
                                                <div className="card-body metric-value p-2">
                                                    <div className="d-flex flex-row-reverse h6">{refineStatus.countUniq}</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col">
                                            <div className="card border-top border-3 border-top-danger mb-0">
                                                <div className="card-header app-stat h5 pt-1 mb-0">API 연동 통합 원</div>
                                                <div className="card-body metric-value p-2">
                                                    <div className="d-flex flex-row-reverse h6">
                                                        <span className="text-success">{`(${((refineStatus.countApiMatched / refineStatus.countUniq) * 100).toFixed(2)}%)`}</span>
                                                        <span className="pr-1">{refineStatus.countApiMatched}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row mt-3">
                                        <div className="col-12">
                                            <DataTable className="display compact cell-border nowrap" ref={this.dataTableRef} onDraw={this.onDraw} {...this.tableSetting} />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12 small text-danger">
                                            <span className="">* 필드 설명</span>
                                            <br />
                                            <span className="ml-3">- 계약 수 > 승인된 총 계약 수(토모노트/별별책방/플라잉)</span>
                                            <br />
                                            <span className="ml-3">- 통합 원 > 통합 DB에 원 정보 등록 여부</span>
                                            <br />
                                            <span className="ml-3">- API > 공공 API 결과와 매칭되는 통합 DB 연동 정보</span>
                                            <br />
                                            <span className="ml-3">- 검수여부 > 원/지사 N:N 연동 업데이트 시 원 정보 검수 여부</span>
                                            <br />
                                        </div>
                                    </div>
                                    {showUpsert ? (
                                        <ModalUpdate
                                            show={showUpsert}
                                            selectedNursery={selected}
                                            locCodes={locCodes}
                                            onUpdate={this.onCUD}
                                            onModalClose={() => this.setState({ showUpsert: false })}
                                        ></ModalUpdate>
                                    ) : (
                                        <></>
                                    )}
                                </div>
                            )}
                            <ToastContainer autoClose={2000} hideProgressBar={true} transition={Slide} />
                        </div>
                    </div>
                </div>
            );
        }
    }
}

export default ManagementNurseryRefine;
